<template>
  <div id="page-wrapper">
    <div id="header2">
      <!-- Nav -->
      <nav id="nav">
        <img
          class="imagetran"
          src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/36571d0c027841b6a16ad96fa941f355.png"
          alt=""
          @click="goLink('Home')"
        />
        <ul>
          <li
            :class="currentRouteName == 'Home' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'Home' ? '100%' : '0',
            }"
          >
            <router-link to="/">
              <a> 首页</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'policy' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'policy' ? '100%' : '0',
            }"
          >
            <router-link to="/policy">
              <a>政策法规</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'vipBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'vipBox' ? '100%' : '0',
            }"
          >
            <router-link to="/vipBox">
              <a>会员单位</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'newBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'newBox' ? '100%' : '0',
            }"
          >
            <router-link to="/newBox">
              <a>新闻动态</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'contact' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'contact' ? '100%' : '0',
            }"
          >
            <router-link to="/contact">
              <a> 联系我们</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'About' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'About' ? '100%' : '0',
            }"
          >
            <router-link to="/About">
              <a>关于协会</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'signUp' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'signUp' ? '100%' : '0',
            }"
          >
            <router-link to="/signUp">
              <a> 护工培训</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'zhaogong' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'zhaogong' ? '100%' : '0',
            }"
          >
            <router-link to="/zhaogong">
              <a> 招工需求</a>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="imageBox">
      <div class="p1 animate__animated animate__zoomIn">会员单位</div>
      <!-- <div class="p2 animate__animated animate__zoomIn">
        苏州市护工协会会员单位
      </div> -->
    </div>
    <div class="new_main_box">
      <!-- 类型切换按钮 -->
      <div class="type-switch-box">
        <button 
          v-for="item in typeList" 
          :key="item.value"
          :class="['switch-btn', currentType === item.value ? 'active' : '']"
          @click="handleTypeChange(item.value)"
        >
          {{ item.label }}
        </button>
      </div>
      <el-table
        :cell-style="cellStyle"
        :header-cell-style="{
          background: '#F5F7FA',
          height: '63px',
          color: '#333333',
        }"
        :data="list"
        stripe
        style="width: 100%"
        @row-click="handleRowClick"
      >
        <el-table-column type="index" label="序号" />
        <el-table-column align="center" prop="company.companyName" label="单位名称">
        </el-table-column>
        <el-table-column align="center" prop="company.contacter" label="代表人">
        </el-table-column>
        <el-table-column align="center" prop="typeName" label="协会任职">
        </el-table-column>
      </el-table>
      <div style="text-align: center">
        <el-pagination
          class="custom-pagination"
          background
          :current-page="pageNum"
          :page-sizes="[10, 20]"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
          style="float: right; margin: 10px 30px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
        />
      </div>
    </div>

    <About></About>
  </div>
</template>
      
      
      <script>
import "../assets/css/main.css";
import "../assets/css/noscript.css";
import { newsList, newsView } from "../api/index";
import About from "./Footer.vue";
import axios from 'axios';

export default {
  name: "Home",
  components: {
    // 注册组件
    About,
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      type: 70,
      currentRouteName: "",
      datails: {},
      currentType: "会长单位", // 当前选中的类型
      typeList: [
        { label: "会长单位", value: "会长单位" },
        { label: "副会长单位", value: "副会长单位" },
        { label: "理事单位", value: "理事单位" },
        { label: "会员单位", value: "会员单位" }
      ]
    };
  },
  methods: {
    goLink(name){
      this.$router.push({
        name: name,
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return "color:#000000;";
    },
    isActive(path) {
      console.log(path, this.$route.path);
      return this.$route.path === path;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.get_newsList(this.type);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.get_newsList(this.type);
    },
    handlePrevClick() {
      this.pageNum--;
      this.get_newsList(this.type);
    },
    handleNextClick() {
      this.pageNum++;
      this.get_newsList(this.type);
    },
    handleTypeChange(typeName) {
      this.currentType = typeName;
      this.pageNum = 1; // 重置页码
      this.get_newsList(this.type);
    },
    get_newsList(type) {
      console.log(type);
      this.type = type;
      // const params = {
      //   accId: 1,
      //   newType: type, //行业资讯,
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize,
      // };
      const params = {
        assId: 1, //行业资讯,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        typeName: this.currentType, // 添加类型参数
      };
      console.log(999, params);
      
      // 直接使用 axios 调用接口
      axios.post('https://hg.xiangban365.com/nursing_mobile/hgassoc/unitList', params, {
        headers: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.list = res.data.dataMap.list;
            // this.get_new_view(this.list[0].id);
            this.total = res.data.dataMap.total;
          } else {
            this.$message(res.data.message);
          }
        })
        .catch((error) => {
          console.error('请求失败:', error);
          this.$message('获取数据失败');
        });
    },
    get_new_view(id) {
      const params = { id: id };
      newsView(params).then((res) => {
        this.datails = res.dataMap;
      });
    },

    handleRowClick(row) {
      if (row.linkUrl) {
        window.open(row.linkUrl);
      }
    },
  },
  mounted() {
    this.currentRouteName = this.$route.name;
    console.log(741, this.currentRouteName);
    this.get_newsList(70);
    // 添加 IntersectionObserver 逻辑
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains("animation-triggered")
        ) {
          entry.target.classList.add("fade-in", "animation-triggered");
        }
      });
    });

    const animatedElements = document.querySelectorAll(
      ".bannerBox2, .bannerBox2, .new_top_box, .bottomBox,.bottom_flex,.new_main_box"
    );
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  },
  created() {},
};
</script>
      
    <style  scoped>
html {
  font-size: 20px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0ba29a !important;
  color: #ffffff !important;
}

.el-pagination {
  float: none !important;
  font-size: 20px !important;
}

.active {
  color: #0ba29a !important;
  font-weight: 600;
}

.linkactive {
  color: #0ba29a !important;
  font-weight: 600;
}

.active1 {
  color: #ffffff;
}

.imageBox {
  background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/243ac7cf940f400ea98d315df1857677.png");
  background-size: 100% 100%;
  color: #fff;
  padding: 12em 18em 12em 18em;
  cursor: default;
  height: 560px;
  text-align: left;
}

.imageBox .p1 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 3em;
  color: #ffffff;
  margin-bottom: 50px;
}

.imageBox .p2 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 1.5em;
  color: #ffffff;
}

.new_main_box {
  padding: 2.5em 18em;
}

.type-switch-box {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.switch-btn {
  padding: 12px 30px;
  border: 2px solid #0ba29a;
  background-color: #ffffff;
  color: #0ba29a;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  outline: none;
}

.switch-btn:hover {
  background-color: #e6f7f6;
}

.switch-btn.active {
  background-color: #0ba29a;
  color: #ffffff !important;
}

.new_top_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.new_top_flex {
  width: 29.4em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new_top_flex .image {
  max-width: 100%;
  height: auto;
}

.new_top_flex .btn {
  position: relative;
  display: inline-block;
  background: #0ba29a;
  color: #fff;
  text-align: center;
  /* border-radius: 0.5em; */
  text-decoration: none;
  padding: 0.65em 3em 0.65em 3em;
  border: 0;
  cursor: pointer;
  outline: 0;
  font-weight: 300;
  width: 200px;
  -moz-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  -webkit-transition: background-color 0.35s ease-in-out,
    color 0.35s ease-in-out, border-bottom-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
}

.new_top_flex .btn:hover {
  color: #fff;
  background: #097c76;
}

.new_top_flex .p1 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.3em;
  color: #333333;
}

.new_top_flex .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #333333;
}

.new_top_flex .btn {
  margin-top: 30px;
}

.bottomBox {
  width: 100%;
  margin-top: 40px;
}

.bottom_flex {
  width: 100%;
  padding: 0.8em 0;
  display: flex;
  justify-content: start;
}

.bottom_img {
  width: 12em;
  height: 7.5em;
  margin-right: 1.995em;
}
.bottom_img .image {
  width: 12em;
  height: 7.5em;
}

.bottom_text {
  width: 61.81em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.bottom_text .p1 {
  font-family: PingFang SC;
  font-size: 1.3em;
  color: #333333;
  font-weight: 800;
}

.bottom_text .p1:hover {
  color: #097c76;
  cursor: pointer;
}
.bottom_text .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #666666;
}

.bottom_text .p2:hover {
  color: #097c76;
  cursor: pointer;
}

.bottom_text_bottom {
  display: flex;
  justify-content: space-between;
}
.bottom_text_bottom .image {
  width: 1.333em;
  height: 1.333em;
}
.bottom_text_bottom .p3 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.7em;
  color: #666666;
}

.bannerBox2 {
  background-color: #ffffff;
}

.bannerBox2 > ul {
  line-height: 80px;
  position: relative;
  display: inline-block;
  margin: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}

.bannerBox2 > ul:after {
  right: 100%;
  margin-right: 1px;
}

.bannerBox2 > ul > li {
  display: inline-block;
  margin: 0px 2em 0 2em;
  border: solid 1px transparent;
  -moz-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -webkit-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -ms-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  color: #333;
}

.bannerBox2 > ul > li > a,
.bannerBox2 > ul > li > span {
  display: block;
  color: inherit;
  text-decoration: none;
  border: 0;
  outline: 0;
}

.bannerBox2 > ul > li > a {
  display: block;
  color: #222222;
  text-align: center;
  text-decoration: none;
  position: relative;
}

.bannerBox2 > ul > li > a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #0ba29a;
  color: #0ba29a;
  transition: width 0.1s ease;
}

.bannerBox2 > ul > li > a:hover::after {
  width: 100%;
}

.bannerBox2 > ul > li > a:hover {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > a.current-page {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > ul {
  display: none;
}

@media screen and (max-width: 1680px) {
  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 1280px) {
  .imageBox{
    padding: 12em 10em 12em 10em;
  }
  .new_main_box{
    padding: 3em 10em;
  }
}

@media screen and (max-width: 960px) {
  .new_main_box{
		padding: 2.5em 10em;
	}
}

@media screen and (max-width: 840px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_main_box{
		padding: 2.5em 10em;
	}

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #434343;
  }

  .new_top_flex .shareBox {
    display: inline-block;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 736px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png");
    background-size: 100% 100%;
    color: #fff;
    padding: 12em 60px 12em 60px;
    cursor: default;
    height: 560px;
    text-align: center;
    line-height: 40px;
  }

  .new_top_box {
    flex-direction: column;
  }

  .new_top_flex:nth-child(1) {
    width: 100%;
    order: 2;
  }

  .new_top_flex:nth-child(2) {
    width: 100%;
    order: 1;
    margin-bottom: 20px;
  }

  .new_main_box {
    padding: 60px;
  }

  .new_top_flex .p1 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 30px;
    color: #0ba29a;
  }

  .new_top_flex .p2 {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #434343;
  }

  .new_top_flex .shareBox .image {
    width: 15em;
    height: 15em;
    text-align: center;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

.ones {
  background: #f5f7fa;
  height: 100px;
  color: #1f1f1f !important;
}

/* 动画样式 */
.fade-in {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  transform: translateY(0);
  animation: fadeInUp 1s ease-in-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
      
      